export const UserRole = {
  USER: 'USER',
  ADMIN: 'ADMIN',
} as const;

export const MemberRole = {
  TEACHER: '선생님',
  PARENT: '학부모',
} as const;
